import * as yup from 'yup'

const schema = yup.object().shape({
  approvalEmailInput: yup.string().email('Email inválido').trim(),

  approvalEmailList: yup
    .array()
    .of(yup.string().email('Email inválido').required('Email é obrigatório')),
})

export default schema
